export const AREA_CHANGE_MESSAGE = 'AreaChangeMessage';
export const PLAN_COMPLETED_MESSAGE = 'PlanCompletedMessage';
export const QUALITY_EXPLICITLY_SET_MESSAGE = 'QualityExplicitlySetMessage';
export const SETTING_CHANGE_MESSAGE = 'SettingChangeMessage';

export const SOCIAL_MESSAGE = 'SocialMessage';
export const STORYLET_MESSAGE = 'StoryletMessage';
export const INVITATION_FROM_YOU = 'InvitationFromYou';
export const INVITATION_TO_YOU = 'InvitationToYou';